import React from "react";

const SpinnerBlockComponent = () => {
    return(
        <div className="spinner" />
    );
};

export default SpinnerBlockComponent;
